import { makeStyles } from "@material-ui/core";
import React from "react";
import { formatPdfName } from "../../helpers/generator/Exporter";
import { CheckCircle, Spinner } from "../components/icons";

const useStyles = makeStyles((theme) => ({
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)"
    }
  },
  root: {
    position: "fixed",
    height: "100%",
    width: "100%",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 3000,
    backgroundColor: "rgba(1,1,1,0.5)",
    "&.hidden": {
      display: "none"
    },
    "& .modal": {
      background: "#1B1E1D",
      padding: "20px",
      borderRadius: "28px",
      fontFamily: "azo-sans-web !important",
      fontSize: "14px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      color: "#D5DDD9",
      fontWeight: 400,
      gap: "10px",
      "& .regenerate": {
        gap: "5px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "10px",
        "& span": {
          color: "#539971",
          display: "block",
          textDecoration: "underline",
          "&:hover": {
            cursor: "pointer"
          }
        }
      },
      "& .buttonsContainer": {
        marginTop: "15px",
        display: "flex",
        flexBasis: "100%",
        gap: "15px",
        justifyContent: "space-between",
        alignItems: "center",
        "& span": {
          "&:hover": {
            cursor: "pointer"
          }
        },
        "& button": {
          "&:hover": {
            cursor: "pointer"
          },
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          padding: "0px",
          gap: "8px",
          background: "#396A4D",
          borderRadius: "100px",
          color: "white",
          fontSize: "14px",
          width: "118px",
          height: "40px",
          "& img": {
            height: "15px",
            width: "auto",
            // #D5DDD9
            filter:
              "invert(100%) sepia(3%) saturate(2538%) hue-rotate(62deg) brightness(89%) contrast(96%)"
          }
        }
      },
      "& .iconTextContainer": {
        display: "flex",
        flexDirection: "row",
        gap: "5px",
        "& img": {
          height: "15px",
          width: "auto",
          // #D5DDD9
          filter:
            "invert(100%) sepia(3%) saturate(2538%) hue-rotate(62deg) brightness(89%) contrast(96%)"
        }
      },
      "& .progressIconContainer": {
        "& span": {
          width: "24px",
          height: "24px",
          fontSize: "24px"
        },
        "& .fa-spin": {
          display: "block",
          animation: "$spin 2s linear infinite"
        }
      },
      "& p": {
        margin: 0
      },
      "& h1": {
        marginTop: 0,
        fontWeight: 400,
        color: "#E6E1E5",
        fontSize: "21px",
        lineHeight: "32px"
      }
    }
  }
}));
export default function PosPdfModal(props) {
  const {
    setExportState,
    exportState,
    readyToDownload,
    cancelGenerate,
    downloadPdf,
    pageCount
  } = props;
  const classes = useStyles();

  return (
    <div className={`${classes.root} removeForExport`}>
      <div className="modal">
        <div
          className={`progressIconContainer ${
            !readyToDownload ? "rotate" : ""
          }`}
        >
          {readyToDownload
            ? CheckCircle({ style: { color: "#539971" } })
            : Spinner({ style: { color: "white" }, className: "fa-spin" })}
        </div>
        <h1>
          {readyToDownload
            ? "Your document is ready."
            : "Generating document..."}
        </h1>
        <p className="product">{formatPdfName(exportState.pdfName, "pos")}</p>
        <div className="iconTextContainer">
          <img src="/fontawesome/regular/files.svg" alt="files" />
          <p>{`${pageCount} page${pageCount > 1 ? "s" : ""}`}</p>
        </div>
        <div className="iconTextContainer">
          <img src="/fontawesome/solid/file-pdf.svg" alt="pdf" />
          <p>PDF Format</p>
        </div>
        <div className="buttonsContainer">
          {readyToDownload && (
            <button
              onClick={downloadPdf}
              className="export-sheet-btn"
              data-sheet-id={exportState.hash}
              data-mapping-enabled="true"
            >
              <img
                src="/fontawesome/regular/file-arrow-down.svg"
                alt="download"
              />
              Download
            </button>
          )}
          <span onClick={cancelGenerate}>Back</span>
        </div>
        {readyToDownload && (
          <div className="regenerate">
            Experiencing issues with the downloaded file?
            <span
              onClick={() => {
                cancelGenerate();
                setExportState({ ...exportState, regenerate: true });
              }}
            >
              Re-generate Document
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
